import { constructs } from "../api/contructs";
import { CreateGenericReducer } from "./CreateGenericReducer";

export const FilterBooksReducer = CreateGenericReducer(constructs["filter-book"]);
